export default __webpack_public_path__ + "static/media/noun-check-3496109.2576a7ba.svg";